// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js";
import { Pen } from "../../Commons/Graphics.js";
import { TerceraComboBox } from "./TerceraComboBox.js";
import { LineStyleUtils } from "../../Commons/UtilsClasses/LineStyleUtils.js";


export let TerceraLineStyleComboBox = TerceraComboBox.extend({
    data: function ()
    {
        return {
            showLastValue: true,
            useStyleProperties: false
        };
    }
});

TerceraLineStyleComboBox.prototype.getType = function () { return 'TerceraLineStyleComboBox' };


TerceraLineStyleComboBox.prototype.oninit = function ()
{
    TerceraComboBox.prototype.oninit.apply(this);

    if (this.get('items').length)
    {
        if (this.get('useStyleProperties'))
        {
            this.setData(null)
            this.menuItems = this.createMenuItems();
        }
        return;
    }

    let arr = LineStyleUtils.getCBItems();
    this.setData(arr)
};

TerceraLineStyleComboBox.prototype.setData = function (arr)
{
    this.set({ listWidth: 150, useImageView: true, imagewidth: 150, updateComboBoxClass: 'upClassLineStyleComboBox' })
    if (arr)
        this.set({ items: arr });
}